import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	assetTypesLabel: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.assets.asset-types-label',
		defaultMessage: 'Asset types',
		description: 'Label for the asset types checkbox select',
	},
	assetTypesPlaceholder: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.assets.asset-types-placeholder',
		defaultMessage: 'Any type',
		description: 'Asset types placeholder and default checkbox',
	},
	assetTypesDisabledTooltip: {
		id: 'issue-type-page.field-associated.field-configuration.assets.asset-types-default-value-disabled-tooltip',
		defaultMessage: 'You can’t edit this field’s asset types',
		description: 'Tooltip shown when the asset types field is disabled and cannot be edited',
	},
	noAssetTypes: {
		id: 'project-settings-apps.issue-type-page.field.field-configuration.assets.no-asset-types',
		defaultMessage: 'No asset types',
		description: 'Asset types checkbox no options message',
	},
});
